import React, {FunctionComponent} from 'react';
import {NavLink} from "react-router-dom";
import Arrow from "../../assets/icons/icon_arrow_right.svg";

interface Props {
    image: string | undefined
    imageAlt: string
    text: string
    link: string
    amountOfLines?: number
}

const PageCard: FunctionComponent<Props> = ({image, imageAlt, text, link, amountOfLines = 1}) => {

    return (
        <div className="pagecard">
            <NavLink end={true} to={link}>
                <img className="pagecard__image" src={image} alt={imageAlt}/>

                <div className="pagecard__pink-section">
                    <h4 className="pagecard__text">{ text }</h4>
                    <img className="pagecard__pink-section__arrow" src={Arrow} alt="arrow" />
                </div>
            </NavLink>
        </div>
    );
};
 
export default PageCard;
